<template>
  <div class="container is-fluid full-viewport" >
    <div class="columns">
      <div class="column is-offset-3 is-6">
        <div class="card">
          <div class="card-content">
            <div class="columns is-multiline is-mobile ">
              <div class="column is-1 pb-0 ">
                <b-button size="is-small" icon-left="reply"  class="align-center" @click="volver()" >
                  <span class="has-text-weight-bold " >
                    volver
                  </span>
                </b-button>
              </div>
              <div class="column is-11 pb-0 ">
                <span class="has-text-weight-bold " >
                  {{ !esEditar ? 'Nuevo Rol' : 'Editar Rol' }}
                </span>
              </div>
            </div>
            <b-field
              label-position="on-border"
							class="select-w100 lbl-align-center"  >
              <template slot="label">
                Descripción
                <b-icon
                  class="pl-1"
                  pack="fas"
                  size="is-small"
                  type="is-danger"
                  icon="asterisk" />
              </template>
              <b-input
                ref="primer_campo"
                maxlength="100"
                v-model="rol.descripcion"
                @blur="rol.descripcion = rol.descripcion ? rol.descripcion.trim() : null " />
            </b-field>
            <b-field
              label-position="on-border"
							class="select-w100 lbl-align-center"  >
              <template slot="label">
                Estado
                <b-icon
                  class="pl-1"
                  pack="fas"
                  size="is-small"
                  type="is-danger"
                  icon="asterisk" />
              </template>
              <b-autocomplete
                open-on-focus
                :data="filteredEstadosArray"
                field="descripcion"
                clearable
                v-model="rol.estado_desc"
                @select="option => rol.estado = option ? option.valor : null" 
                @blur="rol.estado = rol.estado_desc ? rol.estado : null" >
                <template slot-scope="props">
                  <span> {{ props.option.descripcion }} </span>
                </template>
                <template slot="empty">No results found</template>
              </b-autocomplete>
            </b-field>
            <footer class="card-footer">
              <b-button
                v-if="esEditar"
                class="card-footer-item align-center"
                type="is-info"
                @click="actualizar()" >
								<img src="@/assets/icons/Save.png" style="max-height:25px !important" >
                Guardar
              </b-button>
              <b-button
                v-if="!esEditar"
                class="card-footer-item align-center"
                type="is-success"
                @click="guardar()" >
								<img src="@/assets/icons/Save.png" style="max-height:25px !important" >
                Guardar
              </b-button>
              <b-button
                v-if="!esEditar"
                class="card-footer-item align-center"
                type="is-success"
                @click="guardar(true)" >
								<img src="@/assets/icons/Save.png" style="max-height:25px !important" >
                Guardar y Nuevo
              </b-button>
              <b-button
                class="card-footer-item align-center"
                type="is-danger"
                @click="volver()" >
								<img src="@/assets/icons/cancel-4.png" style="max-height:25px !important" >
                Cancelar
              </b-button>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    esEditar: {
      type: Boolean,
      default: false
    },
    objRol: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      rolModelo: {
        id_rol: null,
        descripcion: null,
        estado_desc: 'Activo',
        estado: 'A'
      },
      rol: {},
      listEstados: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.token,
    }),
    filteredEstadosArray() {
      if (this.rol.estado_desc) {
        return this.listEstados.filter((option) => {
          return option.descripcion
            .toString()
            .toLowerCase()
            .indexOf(this.rol.estado_desc.toLowerCase()) >= 0
        })
      } else {
        return this.listEstados
      }
    }
  },
  created () {
    if (this.esEditar) {
      this.rol = { ...this.objRol }
    } else {
      this.rol = { ...this.rolModelo }
    }
    this.llenarCombos()
  },
  mounted() {
    if (this.$refs.primer_campo) {
      this.$refs.primer_campo.focus()
    }
  },
  methods: {
    async llenarCombos () {
      try {
        const params = [this.token, 'Estado', null, null]
				const resultado = await this.$api.ejecutar('spr_sel_catalogos', params)
				if (resultado != null) {
          this.listEstados = [ ...resultado ]
				}
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    },
    volver () {
      this.$router.push({ name: 'Mantenimientos/Roles' })
    },
    async guardar (nuevo = false) {
			if (this.rol.descripcion == null || !this.rol.descripcion ) {
				this.$alertifyNR.genericAlert("No se ha ingresado la descripción del Rol","ERROR")
				return
			}
			if (this.rol.estado == null || !this.rol.estado ) {
				this.$alertifyNR.genericAlert("No se ha seleccionado el Estado del Rol","ERROR")
				return
      }
      const params = [
        this.token,
        this.rol.descripcion,
        this.rol.estado
      ]
      try {
				const resultado = await this.$api.ejecutar('spr_ins_roles', params)
				if (resultado != null) {
          this.$alertifyNR.genericAlert(resultado[0].message, resultado[0].status)
					if (resultado[0].status === 'SUCCESS') {
            if (nuevo) {
              this.rol = { ...this.rolModelo }
              if (this.$refs.primer_campo) {
                await this.$sleep(300)
                this.$refs.primer_campo.focus()
              }
            } else {
              this.volver()
            }
					}
				}
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    },
    async actualizar () {
			if (this.rol.descripcion == null || !this.rol.descripcion ) {
				this.$alertifyNR.genericAlert("No se ha ingresado el la descripción del Rol","ERROR")
				return
			}
			if (this.rol.estado == null || !this.rol.estado ) {
				this.$alertifyNR.genericAlert("No se ha seleccionado el Estado del Rol","ERROR")
				return
      }
      const params = [
        this.token,
        this.rol.id_rol,
        this.rol.descripcion,
        this.rol.estado
      ]
      try {
				const resultado = await this.$api.ejecutar('spr_upd_rol', params)
				if (resultado != null) {
          this.$alertifyNR.genericAlert(resultado[0].message, resultado[0].status)
					if (resultado[0].status === 'SUCCESS') {
            this.volver()
					}
				}
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
    }
  }
}
</script>